import React from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import { ErrorFallback } from '../ErrorFallback'
import { errorLogger } from '../../utils/ErrorHandler'
import { v4 as uuidv4 } from 'uuid'
import { reportFrontendError } from '../../telemetry/rum'

interface WithErrorBoundaryProps {
  boundary?: string
  children: React.ReactNode
}

export const WithErrorBoundary: React.FC<WithErrorBoundaryProps> = ({
  children,
  boundary = 'WithErrorBoundary',
}) => {
  const frontend_track_id = uuidv4()
  return (
    <ErrorBoundary
      fallbackRender={({ error }) => (
        <ErrorFallback error={error} frontend_track_id={frontend_track_id} />
      )}
      onError={(error, info) => {
        errorLogger(error, {
          componentStack: info.componentStack,
          boundary,
          frontend_track_id,
        })
        reportFrontendError('react.errorboundary', error, {
          boundary,
          frontend_track_id,
          componentStack: info.componentStack,
        })
      }}
    >
      {children}
    </ErrorBoundary>
  )
}
